<template>
    <div class="container nopadding">
        <div class="wrapper login">
            <h1 class="white text-center"><b>{{$t('account.nuova_password_label')}}</b></h1><br>
            <div class="content">
                <p>{{$t('account.nuova_password_ind')}}.</p>
                <form>
                    <div class="form-group">
                        <input type="password" class="form-control"
                               :placeholder="$t('password').capitalize()+' *'"
                               autocomplete
                               v-model="form.password">
                    </div>
                    <div class="form-group">
                        <input type="password" class="form-control"
                               placeholder="Conferma password *"
                               autocomplete
                               v-model="form.password_conferma">
                    </div>
                    <router-link :to="{name:'home'}">
                        <button type="button" class="btn btn-default float-left">{{$t('btn_annulla')}}</button>
                    </router-link>
                    <button type="button" class="btn btn-primary float-right"
                            :disabled="this.loading_visible"
                            @click="submit()">
                        {{$t('btn_salva')}}
                    </button>
                    <div class="clearfix"></div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import {resetPassword} from "../../../api/be";
    import router from "../../../routes";

    import ModalErrors from "../../partials/ModalErrors";

    export default {
        name: "Reset",
        components: {ModalErrors},
        data() {
            return {
                form: {
                    token: this.$route.params.token,
                    password: '',
                    password_conferma: ''
                }
            }
        },
        computed: {
            ...mapState('global', {
                loading_visible: state => state.loading_visible
            }),
            ...mapState('localization', {
                language: state => state.language
            }),
            ...mapState('restaurant', {
                id_ristorante: state => state.id,
                locale: state => state.locale
            })
        },
        methods: {
            submit: function () {
                this.showLoading(true);
                resetPassword(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                    ...this.form
                }).then((response) => {
                    router.replace('/utente/login');
                }).catch(({messages}) => {
                    this.showModalErrors({
                        title: 'ACCOUNT',
                        errors: messages
                    });
                }).finally(() => {
                    this.showLoading(false);
                });
            },
            ...mapActions('global', [
                'showLoading',
                'showModalErrors'
            ])
        },
    }
</script>
